import { render, staticRenderFns } from "./NftCollectionMonthVolumeRender.vue?vue&type=template&id=874227b0"
import script from "./NftCollectionMonthVolumeRender.vue?vue&type=script&lang=ts"
export * from "./NftCollectionMonthVolumeRender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports